// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import api from "../api/axiosInstance";
// // import FacebookReviewsWidget from "../components/FacebookReviewsWidget";
// import FacebookReviewsIframe from "../components/FacebookReviewsIframe";

// // const BACKEND_URL = "http://localhost:8081";
// // const BACKEND_URL = "https://api.rangpurgolf.com";

// const ReviewRestaurant = () => {
//   // const [currentSlide, setCurrentSlide] = useState(0);

//   const reviewHeads = [
//     "Ambience & Atmosphere",
//     "Service & Hospitality",
//     "Food & Beverages",
//     // "Value for Money",
//     // "Overall Experience",
//   ];

//   const [ratings, setRatings] = useState(
//     reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {})
//   );
//   const [comments, setComments] = useState(
//     reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
//   );

//   // New state for user details
//   const [userName, setUserName] = useState("");
//   const [userPhone, setUserPhone] = useState("");

//   const [userReviews, setUserReviews] = useState([]);

//   const handleStarClick = (head, star) => {
//     setRatings({ ...ratings, [head]: star });
//   };

//   const fetchReviews = async () => {
//     try {
//       const res = await api.get("/reviews");
//       setUserReviews(res.data);
//     } catch (error) {
//       console.error("Error fetching reviews:", error);
//     }
//   };

//   //api fetch reviews from backend
//   useEffect(() => {
//     // fetch(`${BACKEND_URL}/api/reviews`)
//     //   .then((res) => res.json())
//     //   .then((data) => setUserReviews(data));
//     fetchReviews();
//   }, []);

//   // const handleSubmit = async () => {
//   //   if (!userName || !userPhone) {
//   //     alert("Please enter your name and phone number.");
//   //     return;
//   //   }

//   //   const newReview = { userName, userPhone, ratings, comments };

//   //   // const res = await fetch(`${BACKEND_URL}/api/reviews`, {
//   //   //   method: "POST",
//   //   //   headers: { "Content-Type": "application/json" },
//   //   //   body: JSON.stringify(newReview),
//   //   // });
//   //   const res = await api.post("/reviews", newReview);

//   //   if (!res.ok) {
//   //     const errorMsg = await res.data;
//   //     alert("Error saving review: " + errorMsg);
//   //     return;
//   //   }

//   //   const saved = await res.json();
//   //   setUserReviews([...userReviews, saved]);

//   //   // reset form
//   //   setRatings(reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {}));
//   //   setComments(
//   //     reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
//   //   );
//   //   setUserName("");
//   //   setUserPhone("");

//   //   alert("Thank you for your review!");
//   // };
//   const handleSubmit = async () => {
//     if (!userName || !userPhone) {
//       alert("Please enter your name and phone number.");
//       return;
//     }

//     const newReview = { userName, userPhone, ratings, comments };

//     try {
//       const res = await api.post("/reviews", newReview);

//       // ✅ res.data already contains the parsed response
//       const saved = res.data;
//       setUserReviews([...userReviews, saved]);

//       // ✅ Reset form
//       setRatings(
//         reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {})
//       );
//       setComments(
//         reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
//       );
//       setUserName("");
//       setUserPhone("");

//       alert("Thank you for your review!");
//     } catch (error) {
//       console.error("Error saving review:", error);
//       // Axios error responses are available as error.response
//       const errorMsg =
//         error.response?.data?.message ||
//         "Failed to save review. Please try again.";
//       alert(errorMsg);
//     }
//   };

//   return (
//     <div className="bg-[#fffdf6] min-h-screen py-6 px-4 md:px-8 lg:px-20 flex flex-col lg:flex-row gap-6">
//       {/* Left Column - User Reviews */}

//       <div className="w-full lg:w-1/2 flex flex-col gap-6">
//         <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col">
//           {/* <h2 className="text-2xl font-bold text-center text-lime-500 mb-4">
//             Review The Restaurant
//           </h2> */}
//           <div className="flex items-center justify-between border-b pb-2">
//             <Link
//               to="/restaurant"
//               className="text-lime-500 font-bold text-sm hover:underline"
//             >
//               ← Back to Restaurant
//             </Link>
//             <h2 className="text-2xl font-bold text-center text-lime-500 mb-4">
//               Review The Restaurant
//             </h2>
//           </div>

//           {/* User Info */}
//           <input
//             type="text"
//             placeholder="Your Name"
//             className="w-full border rounded-lg p-2 mb-3 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
//             value={userName}
//             onChange={(e) => setUserName(e.target.value)}
//           />
//           <input
//             type="tel"
//             placeholder="Your Phone Number"
//             className="w-full border rounded-lg p-2 mb-4 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
//             value={userPhone}
//             onChange={(e) => setUserPhone(e.target.value)}
//           />

//           <div className="overflow-y-auto pr-2 space-y-6 max-h-[45vh]">
//             {reviewHeads.map((head) => (
//               <div key={head} className="border-b pb-4">
//                 <h3 className="font-semibold mb-2">{head}</h3>

//                 {/* Stars */}
//                 <div className="flex gap-1 mb-2">
//                   {[1, 2, 3, 4, 5].map((star) => (
//                     <span
//                       key={star}
//                       onClick={() => handleStarClick(head, star)}
//                       className={`cursor-pointer text-xl ${
//                         ratings[head] >= star
//                           ? "text-yellow-500"
//                           : "text-gray-300"
//                       }`}
//                     >
//                       ★
//                     </span>
//                   ))}
//                 </div>

//                 {/* Comment box */}
//                 <textarea
//                   placeholder={`Write about ${head.toLowerCase()}...`}
//                   className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-lime-400 outline-none"
//                   rows={2}
//                   value={comments[head]}
//                   onChange={(e) =>
//                     setComments({ ...comments, [head]: e.target.value })
//                   }
//                 ></textarea>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={handleSubmit}
//             className="mt-4 w-full bg-lime-400 hover:bg-lime-500 text-black py-2 px-4 rounded-lg font-semibold transition"
//           >
//             Submit Rating
//           </button>
//         </div>
//       </div>

//       {/* Right Column - Review Form + Slider */}
//       <div className="w-full lg:w-1/2 flex flex-col gap-6">
//         <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col space-y-6">
//           <div className="flex items-center justify-between border-b pb-2 ">
//             <h2 className="text-xl font-bold text-lime-500">
//               What Others Are Saying
//             </h2>
//             {/* <Link
//               to="/restaurant"
//               className="text-lime-500 font-bold text-sm hover:underline"
//             >
//               ← Back to Restaurant
//             </Link> */}
//           </div>

//           {/* ⭐ Average Rating Summary */}
//           {userReviews.length > 0 && (
//             <div className="bg-gradient-to-r from-lime-100 to-lime-50 border border-lime-200 rounded-xl p-4 flex flex-col space-y-4 shadow-sm">
//               {/* Overall Average */}
//               {(() => {
//                 const totalStars = userReviews.reduce((acc, review) => {
//                   return (
//                     acc +
//                     Object.values(review.ratings).reduce(
//                       (a, b) => a + (b || 0),
//                       0
//                     )
//                   );
//                 }, 0);

//                 const totalRatings = userReviews.reduce((acc, review) => {
//                   return (
//                     acc +
//                     Object.values(review.ratings).filter((r) => r > 0).length
//                   );
//                 }, 0);

//                 const avg =
//                   totalRatings > 0 ? (totalStars / totalRatings).toFixed(1) : 0;

//                 return (
//                   <div className="flex flex-col items-center">
//                     <div className="flex items-center gap-2">
//                       <span className="text-3xl font-bold text-lime-600">
//                         {avg}
//                       </span>
//                       <span className="text-yellow-500 text-2xl">
//                         {"★".repeat(Math.round(avg))}
//                         {"☆".repeat(5 - Math.round(avg))}
//                       </span>
//                     </div>
//                     <p className="text-gray-600 text-sm mt-1">
//                       Based on {userReviews.length}{" "}
//                       {userReviews.length === 1 ? "review" : "reviews"}
//                     </p>
//                   </div>
//                 );
//               })()}

//               {/* Per-Category Averages */}
//               <div className="space-y-2">
//                 {reviewHeads.map((head) => {
//                   const headRatings = userReviews
//                     .map((r) => r.ratings[head] || 0)
//                     .filter((r) => r > 0);
//                   const avgHead =
//                     headRatings.length > 0
//                       ? (
//                           headRatings.reduce((a, b) => a + b, 0) /
//                           headRatings.length
//                         ).toFixed(1)
//                       : 0;

//                   return (
//                     <div
//                       key={head}
//                       className="flex items-center justify-between"
//                     >
//                       <span className="text-sm font-medium text-gray-700 w-32">
//                         {head}
//                       </span>
//                       <div className="flex items-center gap-2 flex-1">
//                         <div className="text-yellow-500 text-sm">
//                           {"★".repeat(Math.round(avgHead))}
//                           {"☆".repeat(5 - Math.round(avgHead))}
//                         </div>
//                         <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
//                           <div
//                             className="h-2 bg-lime-500"
//                             style={{ width: `${(avgHead / 5) * 100}%` }}
//                           ></div>
//                         </div>
//                         <span className="text-xs text-gray-600 w-6 text-right">
//                           {avgHead}
//                         </span>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           {/* List of User Reviews */}
//           {userReviews.length === 0 ? (
//             <p className="text-gray-500 text-center">
//               No reviews yet. Be the first to leave one!
//             </p>
//           ) : (
//             <div className="space-y-6 max-h-[65vh] overflow-y-auto pr-2">
//               {userReviews.map((review, idx) => (
//                 <div
//                   key={idx}
//                   className="border rounded-xl p-4 bg-gradient-to-r from-lime-50 to-white shadow-sm hover:shadow-md transition"
//                 >
//                   <div className="flex justify-between items-center mb-2">
//                     <p className="text-sm font-semibold text-lime-600">
//                       {review.userName}
//                     </p>
//                     <p className="text-xs text-gray-400">{review.date}</p>
//                   </div>
//                   {reviewHeads.map((head) =>
//                     review.ratings[head] > 0 || review.comments[head] ? (
//                       <div key={head} className="mb-3">
//                         <div className="flex items-center justify-between">
//                           <span className="font-semibold text-gray-700">
//                             {head}
//                           </span>
//                           <span className="text-yellow-500">
//                             {"★".repeat(review.ratings[head])}
//                             {"☆".repeat(5 - review.ratings[head])}
//                           </span>
//                         </div>
//                         {review.comments[head] && (
//                           <p className="text-sm text-gray-600 mt-1 italic">
//                             "{review.comments[head]}"
//                           </p>
//                         )}
//                       </div>
//                     ) : null
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//         {/* <div>
//           <FacebookReviewsWidget />
//         </div> */}
//         <div className="bg-white shadow-xl rounded-2xl p-6 flex flex-col space-y-6">
//           <div className="flex items-center justify-between border-b pb-2 mb-2">
//             <h2 className="text-xl font-bold text-blue-500">
//               Facebook Reviews
//             </h2>
//           </div>

//           <FacebookReviewsIframe />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReviewRestaurant;

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Star,
  MessageSquare,
  User,
  Phone,
  Award,
  Sparkles,
  ChevronLeft,
  Send,
  TrendingUp,
  Users,
  PenLine,
  Facebook,
  RefreshCw,
  Heart,
} from "lucide-react";
import api from "../api/axiosInstance";
import FacebookReviewsIframe from "../components/FacebookReviewsIframe";

const ReviewRestaurant = () => {
  const reviewHeads = [
    "Ambience & Atmosphere",
    "Service & Hospitality",
    "Food & Beverages",
  ];

  const [ratings, setRatings] = useState(
    reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {})
  );
  const [comments, setComments] = useState(
    reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
  );

  const [userName, setUserName] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userReviews, setUserReviews] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hoveredStar, setHoveredStar] = useState({ head: null, star: 0 });

  const handleStarClick = (head, star) => {
    setRatings({ ...ratings, [head]: star });
  };

  const handleStarHover = (head, star) => {
    setHoveredStar({ head, star });
  };

  const fetchReviews = async () => {
    try {
      const res = await api.get("/reviews");
      setUserReviews(res.data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const handleSubmit = async () => {
    if (!userName || !userPhone) {
      alert("Please enter your name and phone number.");
      return;
    }

    const newReview = {
      userName,
      userPhone,
      ratings,
      comments,
      date: new Date().toISOString().split("T")[0],
    };

    setIsSubmitting(true);
    try {
      const res = await api.post("/reviews", newReview);
      const saved = res.data;
      setUserReviews([saved, ...userReviews]);

      // Reset form
      setRatings(
        reviewHeads.reduce((acc, head) => ({ ...acc, [head]: 0 }), {})
      );
      setComments(
        reviewHeads.reduce((acc, head) => ({ ...acc, [head]: "" }), {})
      );
      setUserName("");
      setUserPhone("");
      setHoveredStar({ head: null, star: 0 });

      alert("Thank you for your review! Your feedback helps us improve.");
    } catch (error) {
      console.error("Error saving review:", error);
      const errorMsg =
        error.response?.data?.message ||
        "Failed to save review. Please try again.";
      alert(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Calculate average ratings
  const calculateAverages = () => {
    if (userReviews.length === 0) return { overall: 0, categories: {} };

    const categorySums = {};
    const categoryCounts = {};

    reviewHeads.forEach((head) => {
      categorySums[head] = 0;
      categoryCounts[head] = 0;
    });

    let totalStars = 0;
    let totalRatings = 0;

    userReviews.forEach((review) => {
      reviewHeads.forEach((head) => {
        if (review.ratings[head] > 0) {
          categorySums[head] += review.ratings[head];
          categoryCounts[head]++;
          totalStars += review.ratings[head];
          totalRatings++;
        }
      });
    });

    const averages = {};
    reviewHeads.forEach((head) => {
      averages[head] =
        categoryCounts[head] > 0
          ? (categorySums[head] / categoryCounts[head]).toFixed(1)
          : 0;
    });

    const overall =
      totalRatings > 0 ? (totalStars / totalRatings).toFixed(1) : 0;

    return { overall, categories: averages };
  };

  const { overall, categories } = calculateAverages();

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 py-8 px-4 md:px-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-8">
        <div className="flex items-center justify-between">
          <Link
            to="/restaurant"
            className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-800 font-semibold group"
          >
            <ChevronLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Back to Restaurant
          </Link>
          <div className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-emerald-500" />
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
              Share Your Experience
            </h1>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-8">
        {/* Left Column - Review Form */}
        <div className="space-y-8">
          {/* Review Form Card */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-emerald-100">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 mb-4">
                <PenLine className="w-8 h-8 text-emerald-600" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                Rate Your Experience
              </h2>
              <p className="text-gray-600">
                Help us improve by sharing your thoughts
              </p>
            </div>

            {/* User Info */}
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              <div className="relative">
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <User className="w-5 h-5" />
                </div>
                <input
                  type="text"
                  placeholder="Your Name"
                  className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-200 hover:border-emerald-300 focus:border-emerald-400 focus:outline-none transition-colors"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>
              <div className="relative">
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <Phone className="w-5 h-5" />
                </div>
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-200 hover:border-emerald-300 focus:border-emerald-400 focus:outline-none transition-colors"
                  value={userPhone}
                  onChange={(e) => setUserPhone(e.target.value)}
                />
              </div>
            </div>

            {/* Rating Sections */}
            <div className="space-y-8 max-h-[50vh] overflow-y-auto pr-2">
              {reviewHeads.map((head) => (
                <div
                  key={head}
                  className="border-b border-gray-100 pb-8 last:border-0"
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                        {head === "Ambience & Atmosphere" && (
                          <Sparkles className="w-4 h-4 text-emerald-600" />
                        )}
                        {head === "Service & Hospitality" && (
                          <Users className="w-4 h-4 text-emerald-600" />
                        )}
                        {head === "Food & Beverages" && (
                          <Award className="w-4 h-4 text-emerald-600" />
                        )}
                      </div>
                      {head}
                    </h3>
                    <div className="text-sm text-emerald-600 font-semibold">
                      {ratings[head] > 0 ? `${ratings[head]}.0/5` : "Rate"}
                    </div>
                  </div>

                  {/* Stars */}
                  <div className="flex gap-1 mb-6">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <button
                        key={star}
                        onClick={() => handleStarClick(head, star)}
                        onMouseEnter={() => handleStarHover(head, star)}
                        onMouseLeave={() =>
                          setHoveredStar({ head: null, star: 0 })
                        }
                        className={`p-1 transition-all duration-300 ${
                          (hoveredStar.head === head &&
                            hoveredStar.star >= star) ||
                          ratings[head] >= star
                            ? "transform scale-110"
                            : ""
                        }`}
                      >
                        <Star
                          className={`w-8 h-8 ${
                            (hoveredStar.head === head &&
                              hoveredStar.star >= star) ||
                            ratings[head] >= star
                              ? "fill-yellow-400 text-yellow-400"
                              : "text-gray-300"
                          }`}
                        />
                      </button>
                    ))}
                  </div>

                  {/* Comment */}
                  <div className="relative">
                    <div className="absolute left-4 top-4 text-gray-400">
                      <MessageSquare className="w-5 h-5" />
                    </div>
                    <textarea
                      placeholder={`Share your thoughts about ${head.toLowerCase()}...`}
                      className="w-full pl-12 pr-4 py-3 rounded-xl border-2 border-gray-200 hover:border-emerald-300 focus:border-emerald-400 focus:outline-none transition-colors resize-none"
                      rows={3}
                      value={comments[head]}
                      onChange={(e) =>
                        setComments({ ...comments, [head]: e.target.value })
                      }
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Submit Button */}
            <button
              onClick={handleSubmit}
              disabled={isSubmitting || !userName || !userPhone}
              className="group relative w-full py-4 px-6 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl mt-8"
            >
              <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <span className="relative flex items-center justify-center gap-3">
                {isSubmitting ? (
                  <>
                    <RefreshCw className="w-5 h-5 animate-spin" />
                    Submitting...
                  </>
                ) : (
                  <>
                    <Send className="w-5 h-5" />
                    Submit Your Review
                  </>
                )}
              </span>
            </button>
          </div>
        </div>

        {/* Right Column - Reviews & Stats */}
        <div className="space-y-8">
          {/* Stats Card */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-emerald-100">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <TrendingUp className="w-6 h-6 text-emerald-600" />
                Community Ratings
              </h2>
              <div className="px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-sm font-semibold">
                {userReviews.length} Reviews
              </div>
            </div>

            {/* Overall Rating */}
            <div className="text-center mb-8">
              <div className="inline-flex items-baseline gap-2 mb-2">
                <span className="text-5xl font-bold text-gray-900">
                  {overall}
                </span>
                <span className="text-gray-500">/5</span>
              </div>
              <div className="flex items-center justify-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    className={`w-6 h-6 ${
                      star <= Math.floor(overall)
                        ? "fill-yellow-400 text-yellow-400"
                        : star === Math.ceil(overall) && overall % 1 > 0
                        ? "fill-yellow-400 text-yellow-400"
                        : "text-gray-300"
                    }`}
                  />
                ))}
              </div>
              <p className="text-gray-600">
                Based on {userReviews.length} customer reviews
              </p>
            </div>

            {/* Category Breakdown */}
            <div className="space-y-4">
              {reviewHeads.map((head) => {
                const avg = categories[head];
                const percentage = (avg / 5) * 100;

                return (
                  <div key={head} className="space-y-2">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-gray-700">
                        {head}
                      </span>
                      <span className="text-sm font-semibold text-emerald-600">
                        {avg}/5
                      </span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div
                          className="h-2 rounded-full bg-gradient-to-r from-emerald-400 to-lime-400 transition-all duration-1000"
                          style={{ width: `${percentage}%` }}
                        />
                      </div>
                      <div className="flex items-center gap-1">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <Star
                            key={star}
                            className={`w-3 h-3 ${
                              star <= avg
                                ? "fill-yellow-400 text-yellow-400"
                                : "text-gray-300"
                            }`}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* User Reviews */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-emerald-100">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <Heart className="w-6 h-6 text-emerald-600" />
                Recent Reviews
              </h2>
              <button
                onClick={fetchReviews}
                className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                title="Refresh reviews"
              >
                <RefreshCw className="w-5 h-5 text-gray-500" />
              </button>
            </div>

            {userReviews.length === 0 ? (
              <div className="text-center py-12">
                <MessageSquare className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                  No Reviews Yet
                </h3>
                <p className="text-gray-500">
                  Be the first to share your experience!
                </p>
              </div>
            ) : (
              <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">
                {userReviews.map((review, idx) => (
                  <div
                    key={idx}
                    className="bg-gradient-to-br from-emerald-50/50 to-lime-50/50 rounded-xl p-6 border border-emerald-100 hover:shadow-lg transition-all duration-300"
                  >
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h4 className="font-bold text-gray-900">
                          {review.userName}
                        </h4>
                        <p className="text-sm text-gray-500">{review.date}</p>
                      </div>
                      <div className="flex items-center gap-1">
                        {reviewHeads.map(
                          (head) =>
                            review.ratings[head] > 0 && (
                              <div
                                key={head}
                                className="flex items-center gap-1 px-2 py-1 bg-white rounded-full text-xs"
                              >
                                <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
                                <span className="font-semibold">
                                  {review.ratings[head]}
                                </span>
                              </div>
                            )
                        )}
                      </div>
                    </div>

                    <div className="space-y-4">
                      {reviewHeads
                        .filter(
                          (head) =>
                            review.ratings[head] > 0 || review.comments[head]
                        )
                        .map((head) => (
                          <div key={head} className="space-y-2">
                            <div className="flex items-center justify-between">
                              <span className="font-medium text-gray-700">
                                {head}
                              </span>
                              <div className="flex items-center gap-1">
                                {[...Array(5)].map((_, i) => (
                                  <Star
                                    key={i}
                                    className={`w-4 h-4 ${
                                      i < review.ratings[head]
                                        ? "fill-yellow-400 text-yellow-400"
                                        : "text-gray-300"
                                    }`}
                                  />
                                ))}
                              </div>
                            </div>
                            {review.comments[head] && (
                              <p className="text-gray-600 text-sm bg-white/50 p-3 rounded-lg">
                                "{review.comments[head]}"
                              </p>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Facebook Reviews */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-emerald-100">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
                <Facebook className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Facebook Reviews
                </h2>
                <p className="text-gray-600 text-sm">
                  What people are saying on Facebook
                </p>
              </div>
            </div>
            <FacebookReviewsIframe />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewRestaurant;
